var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#C3E7E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1538 23C17 23 17.6923 22.3077 17.6923 21.4615H14.6154C14.6154 22.3077 15.3 23 16.1538 23ZM20.7692 18.3846V14.5385C20.7692 12.1769 19.5077 10.2 17.3077 9.67692V9.15385C17.3077 8.51538 16.7923 8 16.1538 8C15.5154 8 15 8.51538 15 9.15385V9.67692C12.7923 10.2 11.5385 12.1692 11.5385 14.5385V18.3846L10 19.9231V20.6923H22.3077V19.9231L20.7692 18.3846Z",
    fill: "#078A8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueNotification);
export default __webpack_public_path__ + "static/media/blueNotification.27cb99146c1a2f212fc9ef6a17bca9b6.svg";
export { ForwardRef as ReactComponent };